import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Origin design system — tokens first so every variable is defined
// before any component-level class tries to reference it.
import './styles/tokens.css';
import './styles/components.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
